/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PromoCodeRedemptionRequest
 */
export interface PromoCodeRedemptionRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodeRedemptionRequest
     */
    code: string;
}

/**
 * Check if a given object implements the PromoCodeRedemptionRequest interface.
 */
export function instanceOfPromoCodeRedemptionRequest(value: object): value is PromoCodeRedemptionRequest {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function PromoCodeRedemptionRequestFromJSON(json: any): PromoCodeRedemptionRequest {
    return PromoCodeRedemptionRequestFromJSONTyped(json, false);
}

export function PromoCodeRedemptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromoCodeRedemptionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function PromoCodeRedemptionRequestToJSON(json: any): PromoCodeRedemptionRequest {
    return PromoCodeRedemptionRequestToJSONTyped(json, false);
}

export function PromoCodeRedemptionRequestToJSONTyped(value?: PromoCodeRedemptionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
    };
}

